module.exports = __webpack_public_path__ + "vi.9921a1fdaba8e811d528.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/vi.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/vi.svg
// module chunks = styles